import type { DataType } from '../../types/reportBuilder';

/** Canonical color classes for field types — use EVERYWHERE for consistency. */
export const FIELD_COLORS = {
  dimension: {
    bg: 'bg-blue-100',
    border: 'border-blue-200',
    text: 'text-blue-800',
    icon: 'text-blue-600',
    hoverBg: 'hover:bg-blue-50',
    headerBg: '#eff6ff',
  },
  measure: {
    bg: 'bg-green-100',
    border: 'border-green-200',
    text: 'text-green-800',
    icon: 'text-green-600',
    hoverBg: 'hover:bg-green-50',
    headerBg: '#f0fdf4',
  },
  filter: {
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    text: 'text-amber-800',
    icon: 'text-amber-600',
  },
  time: {
    bg: 'bg-teal-100',
    border: 'border-teal-200',
    text: 'text-teal-800',
    icon: 'text-teal-600',
  },
  sort: {
    bg: 'bg-gray-100',
    border: 'border-gray-200',
    text: 'text-gray-700',
    icon: 'text-gray-500',
  },
} as const;

/** Data type icon labels — mirrors Tableau's field-type visual encoding. */
export const DATA_TYPE_LABELS: Record<DataType, { symbol: string; label: string }> = {
  string: { symbol: 'Abc', label: 'Text' },
  integer: { symbol: '#', label: 'Number' },
  decimal: { symbol: '#.#', label: 'Decimal' },
  boolean: { symbol: 'T/F', label: 'Boolean' },
  date: { symbol: '\u{1F4C5}', label: 'Date' },       // calendar emoji as fallback
  timestamp: { symbol: '\u{1F4C5}', label: 'Datetime' },
  uuid: { symbol: 'ID', label: 'ID' },
};

/** Returns pill classes for a field based on type. */
export function pillClasses(type: keyof typeof FIELD_COLORS): string {
  const c = FIELD_COLORS[type];
  return `${c.bg} ${c.border} ${c.text}`;
}
